// extracted by mini-css-extract-plugin
module.exports = {"container":"skills_container__fGinX","line":"skills_line__QAli-","divider":"skills_divider__2nBlv","text":"skills_text__2ryjf","image":"skills_image__2H4O2"};